
export default {
  staticDomain: '//static.hsappstatic.net' || window.location.host,
  staticDomainPrefix: '//static.hsappstatic.net' || ('//' + window.location.host),
  currentProject: 'marketplace-storefront-public-ui',
  currentProjectVersion: 'static-1.11777',
  depVersions: {
  "marketplace-storefront-public-ui": "static-1.11777",
  "apollo-dlb": "static-3.80",
  "client-types": "static-1.454",
  "dashboard-client-types": "static-1.286",
  "data-fetching-client": "static-1.9544",
  "foundations-components": "static-1.7650",
  "foundations-components-legacy": "static-1.675",
  "foundations-theming": "static-1.4279",
  "googlemaps-react-wrapper": "static-1.3",
  "graphql": "static-1.78",
  "head-dlb": "static-1.4884",
  "hs-test-utils": "static-1.7876",
  "hub-http-shared-msw-handlers": "static-1.9645",
  "hubspot-dlb": "static-2.1806",
  "hubspot-url-utils": "static-1.3957",
  "HubStyleTokens": "static-2.11310",
  "I18n": "static-7.1595",
  "jasmine-runner": "static-1.6337",
  "marketplace-storefront-base": "static-1.11838",
  "quartz": "static-1.6819",
  "react-dlb": "static-1.74",
  "react-rhumb": "static-1.16517",
  "react-router-dom": "static-5.26",
  "reactive-variable-buffer-atom": "static-1.2730",
  "reporting-testing-lib": "static-1.8741",
  "settings-ui-lib": "static-1.12390",
  "SharedI18nStrings": "static-1.181",
  "signup-ui-core": "static-1.10391",
  "source-map": "static-1.4",
  "trellis-ecosystem": "static-1.6868",
  "ui-addon-i18n": "static-1.11013",
  "ui-addon-react-router-dom": "static-1.9412",
  "unified-auth": "static-1.303",
  "unified-auth-core-lib": "static-1.584",
  "usage-tracker": "static-1.7202",
  "usage-tracker-core": "static-1.7052",
  "customer-data-property-utils": "static-1.7947",
  "history": "static-4.47",
  "hub-http": "static-1.6085",
  "integrations-lib": "static-1.15633",
  "marketplace-ui-common": "static-1.19150",
  "property-management-iframe": "static-1.12649",
  "quartz-config": "static-1.597",
  "quartz-core": "static-1.6038",
  "quartz-routing": "static-1.249",
  "quick-fetch": "static-1.3801",
  "react": "static-7.182",
  "rpc-client-utils": "static-1.4511",
  "ts-schema": "static-1.3968",
  "ui-universal-auth": "static-1.8789",
  "UIComponents": "static-3.8257",
  "apollo-stack-hubspot": "static-3.79",
  "enviro": "static-4.416",
  "hs-promise-rejection-tracking": "static-1.5433",
  "PortalIdParser": "static-2.377",
  "raven": "static-3.5768",
  "raven-hubspot": "static-1.6075",
  "classnames": "static-2.10",
  "hoist-non-react-statics": "static-3.9",
  "immutable": "static-2.19",
  "metrics-js": "static-1.9436",
  "react-redux": "static-7.67",
  "redux": "static-4.16",
  "styled-components": "static-2.85",
  "bend-plugin-trellis-migration": "static-1.3293",
  "moment": "static-3.26",
  "react-dom": "static-7.85",
  "bend-plugin-quartz": "static-1.3096",
  "quartz-webpack": "static-1.3043",
  "fast-json-stable-stringify": "static-1.4",
  "bend-plugin-foundations-components": "static-1.3919",
  "floating-ui": "static-1.52",
  "foundations-assets": "static-1.4708",
  "foundations-theming-specialty": "static-1.1995",
  "framer-motion": "static-1.68",
  "hs-story-utils": "static-1.9293",
  "react-aria": "static-1.62",
  "react-select-plus": "static-1.65",
  "react-utils": "static-2.5237",
  "react-virtualized": "static-2.95",
  "StyleGuideUI": "static-3.485",
  "tanstack-table": "static-1.51",
  "trellis-assets": "static-1.1405",
  "ui-fonts": "static-1.572",
  "ui-images": "static-2.1120",
  "bend-plugin-foundations-theming": "static-1.2762",
  "foundations-theming-base": "static-1.3264",
  "stylex": "static-1.28",
  "HeadJS": "static-2.728",
  "hs-test-utils-bend-plugin": "static-1.2987",
  "msw": "static-1.39",
  "testing-library": "static-1.148",
  "webpack-env": "static-1.54",
  "i18n-data": "static-1.218",
  "moment-timezone": "static-5.79",
  "jasmine": "static-4.4193",
  "ai-components-ui-library": "static-1.8555",
  "ai-rendering-library": "static-1.9531",
  "chirp-fetch": "static-1.1750",
  "connections-embed-lib": "static-1.730",
  "copilot-toolkit": "static-1.10712",
  "laboratory-lib": "static-3.7026",
  "marketplace-embed": "static-1.21651",
  "marketplace-ui-details": "static-1.9046",
  "marketplace-ui-reviews": "static-1.19106",
  "marketplace-ui-tracking": "static-1.13321",
  "sanitize-text": "static-1.8012",
  "ui-addon-video-player": "static-1.8563",
  "usage-tracker-multi": "static-1.5616",
  "usage-tracker-session-replay": "static-1.4888",
  "wootric-nps": "static-1.6849",
  "apollo-link-hub-http": "static-2.4518",
  "immer": "static-1.33",
  "immerable": "static-1.4021",
  "highcharts": "static-8.100",
  "hs-lodash": "static-4.45",
  "reporting-client-types": "static-1.2409",
  "reporting-data": "static-1.66808",
  "cssUtils": "static-1.760",
  "flux-actions": "static-1.321",
  "HubStyle": "static-2.11618",
  "PatternValidationJS": "static-1.437",
  "react-colorpicker": "static-2.10078",
  "react-dnd": "static-5.6",
  "react-dnd-html5-backend": "static-5.6",
  "redux-observable": "static-1.11",
  "ReduxMessenger": "static-2.10241",
  "rxjs": "static-5.10",
  "underscore": "static-1.8",
  "usage-tracker-container": "static-1.7192",
  "icons": "static-2.635",
  "marketplace-ui-apps-core": "static-1.17683",
  "storybook-react": "static-1.29",
  "trellis-story-utils": "static-1.4387",
  "foundations-components-test-utils": "static-1.5133",
  "quartz-i18n": "static-1.494",
  "react-input-autosize": "static-2.17",
  "fsm": "static-1.3597",
  "customer-data-objects": "static-1.7520",
  "property-translator": "static-1.5276",
  "frontend-preferences-client": "static-1.7791",
  "hs-promise-utils": "static-1.5460",
  "hubspot-apollo-client": "static-1.4746",
  "integrations-error-boundary-lib": "static-1.13048",
  "integrations-tracking-lib": "static-1.5457",
  "native-integrations-shared-strings": "static-1.7654",
  "reselect": "static-2.16",
  "sanitize": "static-1.4341",
  "superstore": "static-1.4636",
  "ui-shepherd-react": "static-3.10013",
  "ai-settings-ui-library": "static-1.7656",
  "hub-http-janus": "static-1.813",
  "hubspotter-http": "static-1.4541",
  "immutable-less": "static-1.4521",
  "marketplace-ui-client-types": "static-1.16557",
  "nav-meta": "static-1.29137",
  "react-window": "static-1.13",
  "self-service-api": "static-1.10109",
  "ui-addon-upgrades": "static-9.17760",
  "inbound-db-properties-service-client": "static-1.3734",
  "property-management-common": "static-1.4937",
  "ui-addon-iframeable": "static-1.8914",
  "dispatcher": "static-1.133",
  "general-store": "static-6.20",
  "mobile-manifest-mixins": "static-1.503",
  "module-federation": "static-1.19",
  "quartz-auth": "static-1.494",
  "quartz-head": "static-1.484",
  "quartz-test": "static-1.494",
  "quartz-tracking": "static-1.198",
  "csstype": "static-1.50",
  "bender-build-tools": "static-1.3022",
  "autolinker": "static-3.11",
  "chatspot-core": "static-1.20619",
  "ContentUtils": "static-1.67832",
  "sassPrefix": "static-1.153",
  "avatar-components": "static-1.2359",
  "customer-data-filters-ui": "static-1.39151",
  "customer-data-objects-ui-components": "static-1.12880",
  "customer-data-reference-ui-components": "static-1.13016",
  "embedded-academy-lib": "static-1.13792",
  "ExportDialog": "static-6.10256",
  "highlight.js": "static-1.75",
  "markdown-it": "static-1.6",
  "reporting-action-components": "static-1.40837",
  "reporting-snowflake": "static-1.55426",
  "reporting-ui-components": "static-2.64079",
  "reporting-visualizations": "static-1.58884",
  "ui-addon-teams": "static-1.21338",
  "magpie-lib": "static-1.5461",
  "magpie-types": "static-1.4921",
  "simple-logging-lib": "static-1.2917",
  "navigation-components": "static-1.17500",
  "ai-studio-lib": "static-1.11184",
  "app-governance-lib": "static-1.1089",
  "developer-experience-shared-components": "static-1.10369",
  "transmute": "static-2.85",
  "ui-addon-integrations-directory-panel": "static-2.7858",
  "ui-product-approvals": "static-1.27680",
  "ui-tool-access": "static-1.10012",
  "usage-based-billing-components-lib": "static-1.8198",
  "usage-tracker-anonymous": "static-1.5619",
  "usage-tracker-public": "static-1.7013",
  "amplitude-session-replay-browser": "static-1.56",
  "inbound-db-meta-service-client": "static-1.3483",
  "persist-promise": "static-1.3575",
  "reference-resolvers": "static-1.8032",
  "ui-extensibility-client-types": "static-1.3808",
  "hubspot-apollo-cache": "static-1.205",
  "universal-page-editor-lib": "static-1.2868",
  "final-form": "static-1.66",
  "redux-toolkit": "static-1.7",
  "simple-data-table": "static-1.2367",
  "merchandise-lib": "static-1.261",
  "atom": "static-1.4937",
  "purchase-motions-components": "static-1.5595",
  "salesImages": "static-1.522",
  "batch-promise": "static-1.1418",
  "crm-component-utils": "static-1.38649",
  "crm-properties-common-lib": "static-1.5740",
  "customer-data-properties": "static-1.51002",
  "framework-data-schema-resolvers": "static-1.6740",
  "property-value-citations": "static-1.1616",
  "reference-resolvers-lite": "static-1.7952",
  "navigation-messaging": "static-1.6827",
  "hubspotter-http-shared-msw-handlers": "static-1.9643",
  "cms-field-types": "static-1.4676",
  "content-icons-ui": "static-1.2184",
  "conversations-skeleton-state": "static-1.7116",
  "crm-message-bus": "static-1.42569",
  "customer-data-filters-ui-msw-helpers": "static-1.21586",
  "customer-data-ui-utilities": "static-1.9691",
  "FormUrlGenerator": "static-2.4588",
  "framework-builder-read-service-client": "static-1.3896",
  "framework-data-schema-quick-fetch": "static-1.6645",
  "multi-account-reference-resolvers": "static-1.844",
  "onboarding-tours": "static-1.16355",
  "react-immutable-proptypes": "static-2.8",
  "reporting-datasets-permissions-lib": "static-1.13253",
  "academy-common-lib": "static-1.13252",
  "content-assistance-lib": "static-1.7542",
  "dashboard-lib": "static-1.80908",
  "file-manager-components": "static-1.23126",
  "getting-started-shared-tasks": "static-1.18070",
  "hubspot-prosemirror": "static-1.17802",
  "hubspot-prosemirror-plugins": "static-1.17794",
  "prosemirror": "static-1.13",
  "rich-text-lib": "static-1.19589",
  "share-with-third-party-component-lib": "static-1.8560",
  "ui-addon-draggable": "static-3.4635",
  "ui-asset-management-lib": "static-1.10806",
  "ui-business-units-lib": "static-1.8900",
  "user-context": "static-1.4967",
  "growth-payments-core": "static-1.24917",
  "reporting-plugins": "static-1.10065",
  "reporting-reports": "static-1.66486",
  "idb-keyval": "static-1.40",
  "reactive-lib": "static-1.592",
  "codemirror": "static-5.91",
  "feedback-loader": "static-1.29007",
  "react-codemirror": "static-1.10493",
  "framework-listing-lib": "static-2.28228",
  "fuzzy": "static-1.8",
  "user-configuration-lib": "static-1.30293",
  "apps-service-types": "static-1.3744",
  "oauth-service-types": "static-1.4114",
  "onboarding-scopes": "static-1.6330",
  "onboarding-tours-client": "static-1.4569",
  "platform-infra-nav-components": "static-1.7555",
  "subscription-experience-data-types": "static-1.14674",
  "crm-record-cards-service-types": "static-1.3505",
  "location-customization-utils-lib": "static-1.8774",
  "redux-thunk": "static-2.43",
  "growth-monetization-service-types": "static-1.4366",
  "nav-client-types": "static-1.2224",
  "purchase-motions-api": "static-1.5598",
  "signup-constants": "static-1.18544",
  "signup-ui-url-generator": "static-2.7902",
  "trials-service-types": "static-1.3767",
  "card-properties-lib": "static-1.43716",
  "commerce-subscription-lib": "static-1.36652",
  "crm-actions": "static-1.6177",
  "crm-cards-sdk": "static-1.43121",
  "customer-data-properties-shared-msw-handlers": "static-1.8972",
  "customer-data-tracking": "static-1.6749",
  "hs-entities": "static-1.554",
  "pulse": "static-1.392",
  "calling-global-api": "static-1.63936",
  "calling-internal-common": "static-1.31167",
  "calling-lifecycle-internal": "static-1.65318",
  "calling-lifecycle-messages": "static-1.57612",
  "commerce-products-lib": "static-1.9032",
  "conditional-properties-service-client": "static-1.3686",
  "crm-links": "static-1.6136",
  "external-options-client-types": "static-1.4047",
  "google-libphonenumber": "static-1.34",
  "inbounddb-objects-service-types": "static-1.4111",
  "meetings-icalendar-utils-lib": "static-1.499",
  "multi-currency-client-types": "static-1.3578",
  "object-builder-ui-client": "static-1.48231",
  "pipeline-validation-client-types": "static-1.3852",
  "smart-property-lib": "static-1.6202",
  "tiered-pricing": "static-1.935",
  "ui-addon-form-validation": "static-1.10860",
  "crm-pipelines-api-client-types": "static-1.4028",
  "react-dnd-compat": "static-1.4487",
  "react-immutable-render-mixin": "static-1.9",
  "growth-data-modal": "static-1.5226",
  "growth-onboarding-confetti": "static-1.2939",
  "growth-onboarding-next-action-utils": "static-1.1475",
  "onboarding-tours-utils": "static-1.421",
  "ui-shepherd-tracker": "static-1.7394",
  "academy-service-client": "static-1.3547",
  "zustand": "static-1.51",
  "ui-coaching-tips": "static-1.28123",
  "redux-actions": "static-3.7",
  "ui-addon-opt": "static-4.8251",
  "video-components-external": "static-1.10787",
  "video-data-lib": "static-1.34445",
  "emoji-mart": "static-3.4",
  "knowledge-content-types": "static-1.8425",
  "payment-link-components": "static-1.23116",
  "ui-addon-emoji-picker": "static-1.9754",
  "EmailSignatureEditor": "static-1.24036",
  "viral-links-lib": "static-1.6907",
  "data-token-picker": "static-1.16161",
  "FileManagerLib": "static-1.38766",
  "react-flip-move": "static-1.66",
  "timezone-utils": "static-2.5111",
  "getting-started-shared-tasks-store": "static-1.17188",
  "campaign-roi-lib": "static-1.8484",
  "diff-match-patch": "static-1.7",
  "browser-eslint": "static-2.57",
  "customer-data-associations": "static-1.7189",
  "customer-data-views-management": "static-1.25126",
  "framework-data-table": "static-2.11583",
  "marketing-platform-lib": "static-1.6712",
  "nudge-client-utils": "static-1.2287",
  "nudge-custom-ui-functions": "static-1.791",
  "app-users-service-client": "static-1.5411",
  "app-users-service-types": "static-1.4819",
  "mini-checkout-client": "static-1.26479",
  "onboarding-utils": "static-1.5219",
  "permissions-shared-i18n-strings-fe": "static-1.1975",
  "ui-coaching-tips-shared-config": "static-1.28108",
  "edison-service-client-types": "static-1.259",
  "eligibility-engine-service-types": "static-1.3048",
  "crm_data": "static-4.91473",
  "customer-data-sidebar": "static-2.45598",
  "enrichment-properties-lib": "static-1.15320",
  "commerce-billing-lib": "static-1.18677",
  "commerce-shared-components-lib": "static-1.18135",
  "commerce-tools-ui-lib": "static-1.9971",
  "crm-fe-perf": "static-1.22771",
  "directed-graph": "static-1.806",
  "event-emitter": "static-1.814",
  "fast-json-patch": "static-1.59",
  "calling-error-reporting": "static-1.31173",
  "shared-worker-versioning": "static-1.10906",
  "calling-usage-tracker": "static-1.6408",
  "voice-sms-access-library": "static-1.443",
  "commerce-permissions": "static-1.630",
  "products-iframe-lib": "static-1.7520",
  "products-ui-components-shared-msw-handlers": "static-1.10027",
  "breeze-intelligence-kit": "static-1.5416",
  "framework-data-schema-resolvers-shared-msw-handlers": "static-1.9728",
  "policy-lib": "static-1.6645",
  "react-tinymce": "static-1.54814",
  "reference-resolvers-lite-shared-msw-handlers": "static-1.9791",
  "tinymce": "static-5.11",
  "tinymce-config": "static-2.53940",
  "tinymce-plugins": "static-1.57054",
  "tinymce-themes": "static-1.55910",
  "growth-onboarding-next-action-components": "static-1.1503",
  "user-context-client": "static-1.4480",
  "growth-onboarding-feedback-components": "static-1.6448",
  "content-media-composition-data-lib": "static-1.11729",
  "content-media-compositions": "static-2.15736",
  "media-bridge-lib": "static-1.18683",
  "commerce-tours-lib": "static-1.5827",
  "growth-onboarding-reliability": "static-1.4953",
  "sales-checkout-service-client": "static-1.3535",
  "draft-convert": "static-2.69",
  "draft-extend": "static-3.71",
  "draft-js": "static-5.74",
  "draft-plugins": "static-2.21427",
  "sales-email-signature-service-client": "static-1.3710",
  "audio-components": "static-1.5706",
  "FileManagerCore": "static-1.38625",
  "FileManagerImages": "static-1.36277",
  "video-components": "static-1.12790",
  "crm-export-dialog": "static-1.6161",
  "crm-index-associations-lib": "static-1.6302",
  "react-beautiful-dnd": "static-1.13",
  "deal-intel-decorators": "static-1.1510",
  "tanstack-virtual": "static-1.26",
  "nudge-custom-function-registry": "static-1.2044",
  "nudge-renderer-utils": "static-1.2363",
  "whisper-core-api": "static-1.6174",
  "InboxConnectUtils": "static-4.14402",
  "emoji-regex": "static-1.7",
  "touchless-buying-components": "static-1.5208",
  "settings-content-modals": "static-1.45653",
  "crm_universal": "static-1.21763",
  "customer-data-email": "static-1.17788",
  "card-payment-highlight-lib": "static-1.36705",
  "card-subscription-highlight-lib": "static-1.39075",
  "commerce-contract-lib": "static-1.11450",
  "customer-data-content": "static-1.27003",
  "invoices-highlight-card-lib": "static-1.54241",
  "orders-highlight-card-lib": "static-1.21045",
  "products-highlight-card-lib": "static-1.17316",
  "project-storage": "static-1.4600",
  "quotes-highlight-card-lib": "static-1.71416",
  "crm-source-interpretation-lib": "static-1.5198",
  "utility-belt": "static-1.2407",
  "payments-enrollment-embed-lib": "static-1.22202",
  "customer-data-rte": "static-1.32613",
  "cv-backend-services": "static-1.1527",
  "growth-onboarding-empty-states": "static-1.5463",
  "payments-post-enroll-local-storage-lib": "static-1.4981",
  "qrcode-generator": "static-1.65",
  "quotes-client-types": "static-1.37506",
  "calling-orchestration-schema": "static-1.35220",
  "sales-views-client-types": "static-1.4135",
  "hub-http-contrib": "static-1.2910",
  "interframe": "static-3.4630",
  "tinymce-data": "static-1.40025",
  "ui-addon-sales-email": "static-1.5080",
  "layout-dnd-components": "static-1.12173",
  "layout-dnd-utils": "static-1.11148",
  "ui-brand-identity-lib": "static-1.14376",
  "NamespacedHubStyle": "static-2.8958",
  "js-cookie": "static-1.18",
  "cropperjs": "static-1.10",
  "urlinator": "static-1.4398",
  "video-embed": "static-1.35279",
  "social-insights-client-types": "static-1.21591",
  "deal-intel-utils": "static-1.1514",
  "checkout-sdk": "static-3.23322",
  "checkout-service-types": "static-1.3715",
  "company-details-components": "static-1.6053",
  "payment-method-components": "static-1.6760",
  "pricing-pages-ui-components": "static-1.12985",
  "quote-checkout-service-types": "static-1.3353",
  "upgrade-catalog-service-types": "static-1.3393",
  "access-control-lib": "static-1.10305",
  "EmailComponents": "static-1.54331",
  "EmailData": "static-1.53008",
  "redux-less": "static-2.9353",
  "sequences-lib": "static-1.7801",
  "ui-gdpr-components": "static-1.10215",
  "products-ui-components": "static-1.39551",
  "quotes-ui-lib": "static-1.80137",
  "SalesContentIndexUI": "static-3.9007",
  "accounting-integrations-ui-components": "static-1.6839",
  "invoices-ui-lib": "static-1.54257",
  "commerce-products-api": "static-1.2060",
  "SafeStorage": "static-1.4269",
  "invoices-iframe-lib": "static-1.56315",
  "quotes-modal-lib": "static-1.102094",
  "stripe-embedded-components": "static-1.7258",
  "draft-content-plugins": "static-1.27881",
  "ContentData": "static-1.67907",
  "layout-data-lib": "static-1.9473",
  "outpost": "static-1.4066",
  "hub-http-rxjs": "static-1.779",
  "normalizr": "static-3.9",
  "ramda": "static-1.7",
  "company-details-service-types": "static-1.3796",
  "billing-payments-client-types": "static-1.3856",
  "account-and-billing-fintech-outages": "static-3.18328",
  "pricing-pages-api": "static-1.12850",
  "ContentComponents": "static-2.70788",
  "marketing-contacts-lib": "static-1.9355",
  "marketing-email-service-types": "static-1.1816",
  "messaging-editing-lib": "static-1.45811",
  "messaging-usage-based-billing-components-lib": "static-1.673",
  "automation-ui-source-apps": "static-1.18420",
  "automation-ui-types": "static-1.19338",
  "messaging-types-lib": "static-1.45548",
  "onboarding-settings-client": "static-1.4372",
  "sequences-client-types-lib": "static-1.7658",
  "commerce-tax-lib": "static-1.385",
  "property-description-translator": "static-1.3722",
  "FireAlarmUi": "static-1.4396",
  "sales-templates-service-types-lib": "static-1.4055",
  "commerce-analytics-service-client": "static-1.3523",
  "totals-ui-components": "static-1.23170",
  "stripe-connect-js": "static-1.65",
  "advanced-menus-core": "static-1.14912",
  "advanced-menus-lib": "static-1.11880",
  "ui-memberships-settings-lib": "static-1.33630",
  "demographics-service-types": "static-1.1516",
  "automation-ui-ubb": "static-1.5254",
  "blueimp-md5": "static-1.8",
  "content-embed-lib": "static-1.7207",
  "data-token-views": "static-1.16142",
  "forms-utils-lib": "static-1.12302",
  "payments-embed-points-lib": "static-1.12740",
  "simple-menus-core": "static-1.14911",
  "simple-menus-lib": "static-1.16428",
  "ui-addon-draggable-compat": "static-2.4121",
  "videoconference-integration-components": "static-1.6622",
  "automation-applications-service-types": "static-1.3399",
  "automation-platform-service-types": "static-1.2544",
  "ContentEditorUI": "static-2.76719",
  "short-messages-app-service-client": "static-1.3867",
  "web-interactives-components": "static-1.13518",
  "web-interactives-data": "static-1.13519",
  "messaging-shared-utils-lib": "static-1.122",
  "messaging-user-info-utils-lib": "static-1.292",
  "email-portal-health-service-types": "static-1.843",
  "commerce-totals-service-types": "static-1.3704",
  "seamless-immutable": "static-7.6",
  "automation-ui-core": "static-2.21274",
  "automation-ui-usage-tracking": "static-1.20737",
  "data-studio-ubb": "static-1.2297",
  "backbone": "static-1.6",
  "campaigns-lib": "static-1.26604",
  "collaboration-sidebar": "static-1.57317",
  "content-management-data-lib": "static-1.5203",
  "copilot-plugins": "static-1.10685",
  "cta-picker": "static-1.36014",
  "customer-agent-discovery-components-lib": "static-1.2629",
  "editor-components": "static-1.13030",
  "editor-iframe-lib": "static-1.8210",
  "error-messaging-js": "static-1.5057",
  "FormsCommonComponents": "static-1.85456",
  "pictos": "static-7.181",
  "react-transition-group": "static-2.61",
  "redux-request-state": "static-1.10513",
  "SharedLegalStrings": "static-1.1620",
  "smart-content-core": "static-1.42036",
  "smart-content-lib": "static-1.42689",
  "social-composer-lib": "static-1.58413",
  "structured-content-lib": "static-1.24795",
  "theme-previewer-lib": "static-1.52864",
  "tinymce-copilot": "static-1.16008",
  "xray-recommendation-lib": "static-1.7687",
  "automation-ui-routing": "static-1.20695",
  "sql-reporting-client-types": "static-1.5530",
  "jquery": "static-3.6",
  "attribution-lib": "static-1.41823",
  "campaigns-utils-lib": "static-1.3022",
  "reporting-enablement": "static-1.22328",
  "chatspot-widget-iframe": "static-1.20611",
  "collaboration-sidebar-common": "static-1.2114",
  "forms-ai-lib": "static-1.4102",
  "codemirror-dlb": "static-1.58278",
  "redux-mock-store": "static-1.8",
  "redux-undo": "static-1.10",
  "seo-tools-lib": "static-1.6295",
  "report-customization-components": "static-1.12711",
  "data-quality-ui-library": "static-1.12492",
  "html-to-image": "static-1.50",
  "reporting-insights-lib": "static-1.1267"
},
  depPathPrefixes: {
  "marketplace-storefront-public-ui": "/marketplace-storefront-public-ui/static-1.11777",
  "apollo-dlb": "/apollo-dlb/static-3.80",
  "client-types": "/client-types/static-1.454",
  "dashboard-client-types": "/dashboard-client-types/static-1.286",
  "data-fetching-client": "/data-fetching-client/static-1.9544",
  "foundations-components": "/foundations-components/static-1.7650",
  "foundations-components-legacy": "/foundations-components-legacy/static-1.675",
  "foundations-theming": "/foundations-theming/static-1.4279",
  "googlemaps-react-wrapper": "/googlemaps-react-wrapper/static-1.3",
  "graphql": "/graphql/static-1.78",
  "head-dlb": "/head-dlb/static-1.4884",
  "hs-test-utils": "/hs-test-utils/static-1.7876",
  "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.9645",
  "hubspot-dlb": "/hubspot-dlb/static-2.1806",
  "hubspot-url-utils": "/hubspot-url-utils/static-1.3957",
  "HubStyleTokens": "/HubStyleTokens/static-2.11310",
  "I18n": "/I18n/static-7.1595",
  "jasmine-runner": "/jasmine-runner/static-1.6337",
  "marketplace-storefront-base": "/marketplace-storefront-base/static-1.11838",
  "quartz": "/quartz/static-1.6819",
  "react-dlb": "/react-dlb/static-1.74",
  "react-rhumb": "/react-rhumb/static-1.16517",
  "react-router-dom": "/react-router-dom/static-5.26",
  "reactive-variable-buffer-atom": "/reactive-variable-buffer-atom/static-1.2730",
  "reporting-testing-lib": "/reporting-testing-lib/static-1.8741",
  "settings-ui-lib": "/settings-ui-lib/static-1.12390",
  "SharedI18nStrings": "/SharedI18nStrings/static-1.181",
  "signup-ui-core": "/signup-ui-core/static-1.10391",
  "source-map": "/source-map/static-1.4",
  "trellis-ecosystem": "/trellis-ecosystem/static-1.6868",
  "ui-addon-i18n": "/ui-addon-i18n/static-1.11013",
  "ui-addon-react-router-dom": "/ui-addon-react-router-dom/static-1.9412",
  "unified-auth": "/unified-auth/static-1.303",
  "unified-auth-core-lib": "/unified-auth-core-lib/static-1.584",
  "usage-tracker": "/usage-tracker/static-1.7202",
  "usage-tracker-core": "/usage-tracker-core/static-1.7052",
  "customer-data-property-utils": "/customer-data-property-utils/static-1.7947",
  "history": "/history/static-4.47",
  "hub-http": "/hub-http/static-1.6085",
  "integrations-lib": "/integrations-lib/static-1.15633",
  "marketplace-ui-common": "/marketplace-ui-common/static-1.19150",
  "property-management-iframe": "/property-management-iframe/static-1.12649",
  "quartz-config": "/quartz-config/static-1.597",
  "quartz-core": "/quartz-core/static-1.6038",
  "quartz-routing": "/quartz-routing/static-1.249",
  "quick-fetch": "/quick-fetch/static-1.3801",
  "react": "/react/static-7.182",
  "rpc-client-utils": "/rpc-client-utils/static-1.4511",
  "ts-schema": "/ts-schema/static-1.3968",
  "ui-universal-auth": "/ui-universal-auth/static-1.8789",
  "UIComponents": "/UIComponents/static-3.8257",
  "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.79",
  "enviro": "/enviro/static-4.416",
  "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.5433",
  "PortalIdParser": "/PortalIdParser/static-2.377",
  "raven": "/raven/static-3.5768",
  "raven-hubspot": "/raven-hubspot/static-1.6075",
  "classnames": "/classnames/static-2.10",
  "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
  "immutable": "/immutable/static-2.19",
  "metrics-js": "/metrics-js/static-1.9436",
  "react-redux": "/react-redux/static-7.67",
  "redux": "/redux/static-4.16",
  "styled-components": "/styled-components/static-2.85",
  "bend-plugin-trellis-migration": "/bend-plugin-trellis-migration/static-1.3293",
  "moment": "/moment/static-3.26",
  "react-dom": "/react-dom/static-7.85",
  "bend-plugin-quartz": "/bend-plugin-quartz/static-1.3096",
  "quartz-webpack": "/quartz-webpack/static-1.3043",
  "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
  "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.3919",
  "floating-ui": "/floating-ui/static-1.52",
  "foundations-assets": "/foundations-assets/static-1.4708",
  "foundations-theming-specialty": "/foundations-theming-specialty/static-1.1995",
  "framer-motion": "/framer-motion/static-1.68",
  "hs-story-utils": "/hs-story-utils/static-1.9293",
  "react-aria": "/react-aria/static-1.62",
  "react-select-plus": "/react-select-plus/static-1.65",
  "react-utils": "/react-utils/static-2.5237",
  "react-virtualized": "/react-virtualized/static-2.95",
  "StyleGuideUI": "/StyleGuideUI/static-3.485",
  "tanstack-table": "/tanstack-table/static-1.51",
  "trellis-assets": "/trellis-assets/static-1.1405",
  "ui-fonts": "/ui-fonts/static-1.572",
  "ui-images": "/ui-images/static-2.1120",
  "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.2762",
  "foundations-theming-base": "/foundations-theming-base/static-1.3264",
  "stylex": "/stylex/static-1.28",
  "HeadJS": "/HeadJS/static-2.728",
  "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.2987",
  "msw": "/msw/static-1.39",
  "testing-library": "/testing-library/static-1.148",
  "webpack-env": "/webpack-env/static-1.54",
  "i18n-data": "/i18n-data/static-1.218",
  "moment-timezone": "/moment-timezone/static-5.79",
  "jasmine": "/jasmine/static-4.4193",
  "ai-components-ui-library": "/ai-components-ui-library/static-1.8555",
  "ai-rendering-library": "/ai-rendering-library/static-1.9531",
  "chirp-fetch": "/chirp-fetch/static-1.1750",
  "connections-embed-lib": "/connections-embed-lib/static-1.730",
  "copilot-toolkit": "/copilot-toolkit/static-1.10712",
  "laboratory-lib": "/laboratory-lib/static-3.7026",
  "marketplace-embed": "/marketplace-embed/static-1.21651",
  "marketplace-ui-details": "/marketplace-ui-details/static-1.9046",
  "marketplace-ui-reviews": "/marketplace-ui-reviews/static-1.19106",
  "marketplace-ui-tracking": "/marketplace-ui-tracking/static-1.13321",
  "sanitize-text": "/sanitize-text/static-1.8012",
  "ui-addon-video-player": "/ui-addon-video-player/static-1.8563",
  "usage-tracker-multi": "/usage-tracker-multi/static-1.5616",
  "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1.4888",
  "wootric-nps": "/wootric-nps/static-1.6849",
  "apollo-link-hub-http": "/apollo-link-hub-http/static-2.4518",
  "immer": "/immer/static-1.33",
  "immerable": "/immerable/static-1.4021",
  "highcharts": "/highcharts/static-8.100",
  "hs-lodash": "/hs-lodash/static-4.45",
  "reporting-client-types": "/reporting-client-types/static-1.2409",
  "reporting-data": "/reporting-data/static-1.66808",
  "cssUtils": "/cssUtils/static-1.760",
  "flux-actions": "/flux-actions/static-1.321",
  "HubStyle": "/HubStyle/static-2.11618",
  "PatternValidationJS": "/PatternValidationJS/static-1.437",
  "react-colorpicker": "/react-colorpicker/static-2.10078",
  "react-dnd": "/react-dnd/static-5.6",
  "react-dnd-html5-backend": "/react-dnd-html5-backend/static-5.6",
  "redux-observable": "/redux-observable/static-1.11",
  "ReduxMessenger": "/ReduxMessenger/static-2.10241",
  "rxjs": "/rxjs/static-5.10",
  "underscore": "/underscore/static-1.8",
  "usage-tracker-container": "/usage-tracker-container/static-1.7192",
  "icons": "/icons/static-2.635",
  "marketplace-ui-apps-core": "/marketplace-ui-apps-core/static-1.17683",
  "storybook-react": "/storybook-react/static-1.29",
  "trellis-story-utils": "/trellis-story-utils/static-1.4387",
  "foundations-components-test-utils": "/foundations-components-test-utils/static-1.5133",
  "quartz-i18n": "/quartz-i18n/static-1.494",
  "react-input-autosize": "/react-input-autosize/static-2.17",
  "fsm": "/fsm/static-1.3597",
  "customer-data-objects": "/customer-data-objects/static-1.7520",
  "property-translator": "/property-translator/static-1.5276",
  "frontend-preferences-client": "/frontend-preferences-client/static-1.7791",
  "hs-promise-utils": "/hs-promise-utils/static-1.5460",
  "hubspot-apollo-client": "/hubspot-apollo-client/static-1.4746",
  "integrations-error-boundary-lib": "/integrations-error-boundary-lib/static-1.13048",
  "integrations-tracking-lib": "/integrations-tracking-lib/static-1.5457",
  "native-integrations-shared-strings": "/native-integrations-shared-strings/static-1.7654",
  "reselect": "/reselect/static-2.16",
  "sanitize": "/sanitize/static-1.4341",
  "superstore": "/superstore/static-1.4636",
  "ui-shepherd-react": "/ui-shepherd-react/static-3.10013",
  "ai-settings-ui-library": "/ai-settings-ui-library/static-1.7656",
  "hub-http-janus": "/hub-http-janus/static-1.813",
  "hubspotter-http": "/hubspotter-http/static-1.4541",
  "immutable-less": "/immutable-less/static-1.4521",
  "marketplace-ui-client-types": "/marketplace-ui-client-types/static-1.16557",
  "nav-meta": "/nav-meta/static-1.29137",
  "react-window": "/react-window/static-1.13",
  "self-service-api": "/self-service-api/static-1.10109",
  "ui-addon-upgrades": "/ui-addon-upgrades/static-9.17760",
  "inbound-db-properties-service-client": "/inbound-db-properties-service-client/static-1.3734",
  "property-management-common": "/property-management-common/static-1.4937",
  "ui-addon-iframeable": "/ui-addon-iframeable/static-1.8914",
  "dispatcher": "/dispatcher/static-1.133",
  "general-store": "/general-store/static-6.20",
  "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.503",
  "module-federation": "/module-federation/static-1.19",
  "quartz-auth": "/quartz-auth/static-1.494",
  "quartz-head": "/quartz-head/static-1.484",
  "quartz-test": "/quartz-test/static-1.494",
  "quartz-tracking": "/quartz-tracking/static-1.198",
  "csstype": "/csstype/static-1.50",
  "bender-build-tools": "/bender-build-tools/static-1.3022",
  "autolinker": "/autolinker/static-3.11",
  "chatspot-core": "/chatspot-core/static-1.20619",
  "ContentUtils": "/ContentUtils/static-1.67832",
  "sassPrefix": "/sassPrefix/static-1.153",
  "avatar-components": "/avatar-components/static-1.2359",
  "customer-data-filters-ui": "/customer-data-filters-ui/static-1.39151",
  "customer-data-objects-ui-components": "/customer-data-objects-ui-components/static-1.12880",
  "customer-data-reference-ui-components": "/customer-data-reference-ui-components/static-1.13016",
  "embedded-academy-lib": "/embedded-academy-lib/static-1.13792",
  "ExportDialog": "/ExportDialog/static-6.10256",
  "highlight.js": "/highlight.js/static-1.75",
  "markdown-it": "/markdown-it/static-1.6",
  "reporting-action-components": "/reporting-action-components/static-1.40837",
  "reporting-snowflake": "/reporting-snowflake/static-1.55426",
  "reporting-ui-components": "/reporting-ui-components/static-2.64079",
  "reporting-visualizations": "/reporting-visualizations/static-1.58884",
  "ui-addon-teams": "/ui-addon-teams/static-1.21338",
  "magpie-lib": "/magpie-lib/static-1.5461",
  "magpie-types": "/magpie-types/static-1.4921",
  "simple-logging-lib": "/simple-logging-lib/static-1.2917",
  "navigation-components": "/navigation-components/static-1.17500",
  "ai-studio-lib": "/ai-studio-lib/static-1.11184",
  "app-governance-lib": "/app-governance-lib/static-1.1089",
  "developer-experience-shared-components": "/developer-experience-shared-components/static-1.10369",
  "transmute": "/transmute/static-2.85",
  "ui-addon-integrations-directory-panel": "/ui-addon-integrations-directory-panel/static-2.7858",
  "ui-product-approvals": "/ui-product-approvals/static-1.27680",
  "ui-tool-access": "/ui-tool-access/static-1.10012",
  "usage-based-billing-components-lib": "/usage-based-billing-components-lib/static-1.8198",
  "usage-tracker-anonymous": "/usage-tracker-anonymous/static-1.5619",
  "usage-tracker-public": "/usage-tracker-public/static-1.7013",
  "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.56",
  "inbound-db-meta-service-client": "/inbound-db-meta-service-client/static-1.3483",
  "persist-promise": "/persist-promise/static-1.3575",
  "reference-resolvers": "/reference-resolvers/static-1.8032",
  "ui-extensibility-client-types": "/ui-extensibility-client-types/static-1.3808",
  "hubspot-apollo-cache": "/hubspot-apollo-cache/static-1.205",
  "universal-page-editor-lib": "/universal-page-editor-lib/static-1.2868",
  "final-form": "/final-form/static-1.66",
  "redux-toolkit": "/redux-toolkit/static-1.7",
  "simple-data-table": "/simple-data-table/static-1.2367",
  "merchandise-lib": "/merchandise-lib/static-1.261",
  "atom": "/atom/static-1.4937",
  "purchase-motions-components": "/purchase-motions-components/static-1.5595",
  "salesImages": "/salesImages/static-1.522",
  "batch-promise": "/batch-promise/static-1.1418",
  "crm-component-utils": "/crm-component-utils/static-1.38649",
  "crm-properties-common-lib": "/crm-properties-common-lib/static-1.5740",
  "customer-data-properties": "/customer-data-properties/static-1.51002",
  "framework-data-schema-resolvers": "/framework-data-schema-resolvers/static-1.6740",
  "property-value-citations": "/property-value-citations/static-1.1616",
  "reference-resolvers-lite": "/reference-resolvers-lite/static-1.7952",
  "navigation-messaging": "/navigation-messaging/static-1.6827",
  "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.9643",
  "cms-field-types": "/cms-field-types/static-1.4676",
  "content-icons-ui": "/content-icons-ui/static-1.2184",
  "conversations-skeleton-state": "/conversations-skeleton-state/static-1.7116",
  "crm-message-bus": "/crm-message-bus/static-1.42569",
  "customer-data-filters-ui-msw-helpers": "/customer-data-filters-ui-msw-helpers/static-1.21586",
  "customer-data-ui-utilities": "/customer-data-ui-utilities/static-1.9691",
  "FormUrlGenerator": "/FormUrlGenerator/static-2.4588",
  "framework-builder-read-service-client": "/framework-builder-read-service-client/static-1.3896",
  "framework-data-schema-quick-fetch": "/framework-data-schema-quick-fetch/static-1.6645",
  "multi-account-reference-resolvers": "/multi-account-reference-resolvers/static-1.844",
  "onboarding-tours": "/onboarding-tours/static-1.16355",
  "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
  "reporting-datasets-permissions-lib": "/reporting-datasets-permissions-lib/static-1.13253",
  "academy-common-lib": "/academy-common-lib/static-1.13252",
  "content-assistance-lib": "/content-assistance-lib/static-1.7542",
  "dashboard-lib": "/dashboard-lib/static-1.80908",
  "file-manager-components": "/file-manager-components/static-1.23126",
  "getting-started-shared-tasks": "/getting-started-shared-tasks/static-1.18070",
  "hubspot-prosemirror": "/hubspot-prosemirror/static-1.17802",
  "hubspot-prosemirror-plugins": "/hubspot-prosemirror-plugins/static-1.17794",
  "prosemirror": "/prosemirror/static-1.13",
  "rich-text-lib": "/rich-text-lib/static-1.19589",
  "share-with-third-party-component-lib": "/share-with-third-party-component-lib/static-1.8560",
  "ui-addon-draggable": "/ui-addon-draggable/static-3.4635",
  "ui-asset-management-lib": "/ui-asset-management-lib/static-1.10806",
  "ui-business-units-lib": "/ui-business-units-lib/static-1.8900",
  "user-context": "/user-context/static-1.4967",
  "growth-payments-core": "/growth-payments-core/static-1.24917",
  "reporting-plugins": "/reporting-plugins/static-1.10065",
  "reporting-reports": "/reporting-reports/static-1.66486",
  "idb-keyval": "/idb-keyval/static-1.40",
  "reactive-lib": "/reactive-lib/static-1.592",
  "codemirror": "/codemirror/static-5.91",
  "feedback-loader": "/feedback-loader/static-1.29007",
  "react-codemirror": "/react-codemirror/static-1.10493",
  "framework-listing-lib": "/framework-listing-lib/static-2.28228",
  "fuzzy": "/fuzzy/static-1.8",
  "user-configuration-lib": "/user-configuration-lib/static-1.30293",
  "apps-service-types": "/apps-service-types/static-1.3744",
  "oauth-service-types": "/oauth-service-types/static-1.4114",
  "onboarding-scopes": "/onboarding-scopes/static-1.6330",
  "onboarding-tours-client": "/onboarding-tours-client/static-1.4569",
  "platform-infra-nav-components": "/platform-infra-nav-components/static-1.7555",
  "subscription-experience-data-types": "/subscription-experience-data-types/static-1.14674",
  "crm-record-cards-service-types": "/crm-record-cards-service-types/static-1.3505",
  "location-customization-utils-lib": "/location-customization-utils-lib/static-1.8774",
  "redux-thunk": "/redux-thunk/static-2.43",
  "growth-monetization-service-types": "/growth-monetization-service-types/static-1.4366",
  "nav-client-types": "/nav-client-types/static-1.2224",
  "purchase-motions-api": "/purchase-motions-api/static-1.5598",
  "signup-constants": "/signup-constants/static-1.18544",
  "signup-ui-url-generator": "/signup-ui-url-generator/static-2.7902",
  "trials-service-types": "/trials-service-types/static-1.3767",
  "card-properties-lib": "/card-properties-lib/static-1.43716",
  "commerce-subscription-lib": "/commerce-subscription-lib/static-1.36652",
  "crm-actions": "/crm-actions/static-1.6177",
  "crm-cards-sdk": "/crm-cards-sdk/static-1.43121",
  "customer-data-properties-shared-msw-handlers": "/customer-data-properties-shared-msw-handlers/static-1.8972",
  "customer-data-tracking": "/customer-data-tracking/static-1.6749",
  "hs-entities": "/hs-entities/static-1.554",
  "pulse": "/pulse/static-1.392",
  "calling-global-api": "/calling-global-api/static-1.63936",
  "calling-internal-common": "/calling-internal-common/static-1.31167",
  "calling-lifecycle-internal": "/calling-lifecycle-internal/static-1.65318",
  "calling-lifecycle-messages": "/calling-lifecycle-messages/static-1.57612",
  "commerce-products-lib": "/commerce-products-lib/static-1.9032",
  "conditional-properties-service-client": "/conditional-properties-service-client/static-1.3686",
  "crm-links": "/crm-links/static-1.6136",
  "external-options-client-types": "/external-options-client-types/static-1.4047",
  "google-libphonenumber": "/google-libphonenumber/static-1.34",
  "inbounddb-objects-service-types": "/inbounddb-objects-service-types/static-1.4111",
  "meetings-icalendar-utils-lib": "/meetings-icalendar-utils-lib/static-1.499",
  "multi-currency-client-types": "/multi-currency-client-types/static-1.3578",
  "object-builder-ui-client": "/object-builder-ui-client/static-1.48231",
  "pipeline-validation-client-types": "/pipeline-validation-client-types/static-1.3852",
  "smart-property-lib": "/smart-property-lib/static-1.6202",
  "tiered-pricing": "/tiered-pricing/static-1.935",
  "ui-addon-form-validation": "/ui-addon-form-validation/static-1.10860",
  "crm-pipelines-api-client-types": "/crm-pipelines-api-client-types/static-1.4028",
  "react-dnd-compat": "/react-dnd-compat/static-1.4487",
  "react-immutable-render-mixin": "/react-immutable-render-mixin/static-1.9",
  "growth-data-modal": "/growth-data-modal/static-1.5226",
  "growth-onboarding-confetti": "/growth-onboarding-confetti/static-1.2939",
  "growth-onboarding-next-action-utils": "/growth-onboarding-next-action-utils/static-1.1475",
  "onboarding-tours-utils": "/onboarding-tours-utils/static-1.421",
  "ui-shepherd-tracker": "/ui-shepherd-tracker/static-1.7394",
  "academy-service-client": "/academy-service-client/static-1.3547",
  "zustand": "/zustand/static-1.51",
  "ui-coaching-tips": "/ui-coaching-tips/static-1.28123",
  "redux-actions": "/redux-actions/static-3.7",
  "ui-addon-opt": "/ui-addon-opt/static-4.8251",
  "video-components-external": "/video-components-external/static-1.10787",
  "video-data-lib": "/video-data-lib/static-1.34445",
  "emoji-mart": "/emoji-mart/static-3.4",
  "knowledge-content-types": "/knowledge-content-types/static-1.8425",
  "payment-link-components": "/payment-link-components/static-1.23116",
  "ui-addon-emoji-picker": "/ui-addon-emoji-picker/static-1.9754",
  "EmailSignatureEditor": "/EmailSignatureEditor/static-1.24036",
  "viral-links-lib": "/viral-links-lib/static-1.6907",
  "data-token-picker": "/data-token-picker/static-1.16161",
  "FileManagerLib": "/FileManagerLib/static-1.38766",
  "react-flip-move": "/react-flip-move/static-1.66",
  "timezone-utils": "/timezone-utils/static-2.5111",
  "getting-started-shared-tasks-store": "/getting-started-shared-tasks-store/static-1.17188",
  "campaign-roi-lib": "/campaign-roi-lib/static-1.8484",
  "diff-match-patch": "/diff-match-patch/static-1.7",
  "browser-eslint": "/browser-eslint/static-2.57",
  "customer-data-associations": "/customer-data-associations/static-1.7189",
  "customer-data-views-management": "/customer-data-views-management/static-1.25126",
  "framework-data-table": "/framework-data-table/static-2.11583",
  "marketing-platform-lib": "/marketing-platform-lib/static-1.6712",
  "nudge-client-utils": "/nudge-client-utils/static-1.2287",
  "nudge-custom-ui-functions": "/nudge-custom-ui-functions/static-1.791",
  "app-users-service-client": "/app-users-service-client/static-1.5411",
  "app-users-service-types": "/app-users-service-types/static-1.4819",
  "mini-checkout-client": "/mini-checkout-client/static-1.26479",
  "onboarding-utils": "/onboarding-utils/static-1.5219",
  "permissions-shared-i18n-strings-fe": "/permissions-shared-i18n-strings-fe/static-1.1975",
  "ui-coaching-tips-shared-config": "/ui-coaching-tips-shared-config/static-1.28108",
  "edison-service-client-types": "/edison-service-client-types/static-1.259",
  "eligibility-engine-service-types": "/eligibility-engine-service-types/static-1.3048",
  "crm_data": "/crm_data/static-4.91473",
  "customer-data-sidebar": "/customer-data-sidebar/static-2.45598",
  "enrichment-properties-lib": "/enrichment-properties-lib/static-1.15320",
  "commerce-billing-lib": "/commerce-billing-lib/static-1.18677",
  "commerce-shared-components-lib": "/commerce-shared-components-lib/static-1.18135",
  "commerce-tools-ui-lib": "/commerce-tools-ui-lib/static-1.9971",
  "crm-fe-perf": "/crm-fe-perf/static-1.22771",
  "directed-graph": "/directed-graph/static-1.806",
  "event-emitter": "/event-emitter/static-1.814",
  "fast-json-patch": "/fast-json-patch/static-1.59",
  "calling-error-reporting": "/calling-error-reporting/static-1.31173",
  "shared-worker-versioning": "/shared-worker-versioning/static-1.10906",
  "calling-usage-tracker": "/calling-usage-tracker/static-1.6408",
  "voice-sms-access-library": "/voice-sms-access-library/static-1.443",
  "commerce-permissions": "/commerce-permissions/static-1.630",
  "products-iframe-lib": "/products-iframe-lib/static-1.7520",
  "products-ui-components-shared-msw-handlers": "/products-ui-components-shared-msw-handlers/static-1.10027",
  "breeze-intelligence-kit": "/breeze-intelligence-kit/static-1.5416",
  "framework-data-schema-resolvers-shared-msw-handlers": "/framework-data-schema-resolvers-shared-msw-handlers/static-1.9728",
  "policy-lib": "/policy-lib/static-1.6645",
  "react-tinymce": "/react-tinymce/static-1.54814",
  "reference-resolvers-lite-shared-msw-handlers": "/reference-resolvers-lite-shared-msw-handlers/static-1.9791",
  "tinymce": "/tinymce/static-5.11",
  "tinymce-config": "/tinymce-config/static-2.53940",
  "tinymce-plugins": "/tinymce-plugins/static-1.57054",
  "tinymce-themes": "/tinymce-themes/static-1.55910",
  "growth-onboarding-next-action-components": "/growth-onboarding-next-action-components/static-1.1503",
  "user-context-client": "/user-context-client/static-1.4480",
  "growth-onboarding-feedback-components": "/growth-onboarding-feedback-components/static-1.6448",
  "content-media-composition-data-lib": "/content-media-composition-data-lib/static-1.11729",
  "content-media-compositions": "/content-media-compositions/static-2.15736",
  "media-bridge-lib": "/media-bridge-lib/static-1.18683",
  "commerce-tours-lib": "/commerce-tours-lib/static-1.5827",
  "growth-onboarding-reliability": "/growth-onboarding-reliability/static-1.4953",
  "sales-checkout-service-client": "/sales-checkout-service-client/static-1.3535",
  "draft-convert": "/draft-convert/static-2.69",
  "draft-extend": "/draft-extend/static-3.71",
  "draft-js": "/draft-js/static-5.74",
  "draft-plugins": "/draft-plugins/static-2.21427",
  "sales-email-signature-service-client": "/sales-email-signature-service-client/static-1.3710",
  "audio-components": "/audio-components/static-1.5706",
  "FileManagerCore": "/FileManagerCore/static-1.38625",
  "FileManagerImages": "/FileManagerImages/static-1.36277",
  "video-components": "/video-components/static-1.12790",
  "crm-export-dialog": "/crm-export-dialog/static-1.6161",
  "crm-index-associations-lib": "/crm-index-associations-lib/static-1.6302",
  "react-beautiful-dnd": "/react-beautiful-dnd/static-1.13",
  "deal-intel-decorators": "/deal-intel-decorators/static-1.1510",
  "tanstack-virtual": "/tanstack-virtual/static-1.26",
  "nudge-custom-function-registry": "/nudge-custom-function-registry/static-1.2044",
  "nudge-renderer-utils": "/nudge-renderer-utils/static-1.2363",
  "whisper-core-api": "/whisper-core-api/static-1.6174",
  "InboxConnectUtils": "/InboxConnectUtils/static-4.14402",
  "emoji-regex": "/emoji-regex/static-1.7",
  "touchless-buying-components": "/touchless-buying-components/static-1.5208",
  "settings-content-modals": "/settings-content-modals/static-1.45653",
  "crm_universal": "/crm_universal/static-1.21763",
  "customer-data-email": "/customer-data-email/static-1.17788",
  "card-payment-highlight-lib": "/card-payment-highlight-lib/static-1.36705",
  "card-subscription-highlight-lib": "/card-subscription-highlight-lib/static-1.39075",
  "commerce-contract-lib": "/commerce-contract-lib/static-1.11450",
  "customer-data-content": "/customer-data-content/static-1.27003",
  "invoices-highlight-card-lib": "/invoices-highlight-card-lib/static-1.54241",
  "orders-highlight-card-lib": "/orders-highlight-card-lib/static-1.21045",
  "products-highlight-card-lib": "/products-highlight-card-lib/static-1.17316",
  "project-storage": "/project-storage/static-1.4600",
  "quotes-highlight-card-lib": "/quotes-highlight-card-lib/static-1.71416",
  "crm-source-interpretation-lib": "/crm-source-interpretation-lib/static-1.5198",
  "utility-belt": "/utility-belt/static-1.2407",
  "payments-enrollment-embed-lib": "/payments-enrollment-embed-lib/static-1.22202",
  "customer-data-rte": "/customer-data-rte/static-1.32613",
  "cv-backend-services": "/cv-backend-services/static-1.1527",
  "growth-onboarding-empty-states": "/growth-onboarding-empty-states/static-1.5463",
  "payments-post-enroll-local-storage-lib": "/payments-post-enroll-local-storage-lib/static-1.4981",
  "qrcode-generator": "/qrcode-generator/static-1.65",
  "quotes-client-types": "/quotes-client-types/static-1.37506",
  "calling-orchestration-schema": "/calling-orchestration-schema/static-1.35220",
  "sales-views-client-types": "/sales-views-client-types/static-1.4135",
  "hub-http-contrib": "/hub-http-contrib/static-1.2910",
  "interframe": "/interframe/static-3.4630",
  "tinymce-data": "/tinymce-data/static-1.40025",
  "ui-addon-sales-email": "/ui-addon-sales-email/static-1.5080",
  "layout-dnd-components": "/layout-dnd-components/static-1.12173",
  "layout-dnd-utils": "/layout-dnd-utils/static-1.11148",
  "ui-brand-identity-lib": "/ui-brand-identity-lib/static-1.14376",
  "NamespacedHubStyle": "/NamespacedHubStyle/static-2.8958",
  "js-cookie": "/js-cookie/static-1.18",
  "cropperjs": "/cropperjs/static-1.10",
  "urlinator": "/urlinator/static-1.4398",
  "video-embed": "/video-embed/static-1.35279",
  "social-insights-client-types": "/social-insights-client-types/static-1.21591",
  "deal-intel-utils": "/deal-intel-utils/static-1.1514",
  "checkout-sdk": "/checkout-sdk/static-3.23322",
  "checkout-service-types": "/checkout-service-types/static-1.3715",
  "company-details-components": "/company-details-components/static-1.6053",
  "payment-method-components": "/payment-method-components/static-1.6760",
  "pricing-pages-ui-components": "/pricing-pages-ui-components/static-1.12985",
  "quote-checkout-service-types": "/quote-checkout-service-types/static-1.3353",
  "upgrade-catalog-service-types": "/upgrade-catalog-service-types/static-1.3393",
  "access-control-lib": "/access-control-lib/static-1.10305",
  "EmailComponents": "/EmailComponents/static-1.54331",
  "EmailData": "/EmailData/static-1.53008",
  "redux-less": "/redux-less/static-2.9353",
  "sequences-lib": "/sequences-lib/static-1.7801",
  "ui-gdpr-components": "/ui-gdpr-components/static-1.10215",
  "products-ui-components": "/products-ui-components/static-1.39551",
  "quotes-ui-lib": "/quotes-ui-lib/static-1.80137",
  "SalesContentIndexUI": "/SalesContentIndexUI/static-3.9007",
  "accounting-integrations-ui-components": "/accounting-integrations-ui-components/static-1.6839",
  "invoices-ui-lib": "/invoices-ui-lib/static-1.54257",
  "commerce-products-api": "/commerce-products-api/static-1.2060",
  "SafeStorage": "/SafeStorage/static-1.4269",
  "invoices-iframe-lib": "/invoices-iframe-lib/static-1.56315",
  "quotes-modal-lib": "/quotes-modal-lib/static-1.102094",
  "stripe-embedded-components": "/stripe-embedded-components/static-1.7258",
  "draft-content-plugins": "/draft-content-plugins/static-1.27881",
  "ContentData": "/ContentData/static-1.67907",
  "layout-data-lib": "/layout-data-lib/static-1.9473",
  "outpost": "/outpost/static-1.4066",
  "hub-http-rxjs": "/hub-http-rxjs/static-1.779",
  "normalizr": "/normalizr/static-3.9",
  "ramda": "/ramda/static-1.7",
  "company-details-service-types": "/company-details-service-types/static-1.3796",
  "billing-payments-client-types": "/billing-payments-client-types/static-1.3856",
  "account-and-billing-fintech-outages": "/account-and-billing-fintech-outages/static-3.18328",
  "pricing-pages-api": "/pricing-pages-api/static-1.12850",
  "ContentComponents": "/ContentComponents/static-2.70788",
  "marketing-contacts-lib": "/marketing-contacts-lib/static-1.9355",
  "marketing-email-service-types": "/marketing-email-service-types/static-1.1816",
  "messaging-editing-lib": "/messaging-editing-lib/static-1.45811",
  "messaging-usage-based-billing-components-lib": "/messaging-usage-based-billing-components-lib/static-1.673",
  "automation-ui-source-apps": "/automation-ui-source-apps/static-1.18420",
  "automation-ui-types": "/automation-ui-types/static-1.19338",
  "messaging-types-lib": "/messaging-types-lib/static-1.45548",
  "onboarding-settings-client": "/onboarding-settings-client/static-1.4372",
  "sequences-client-types-lib": "/sequences-client-types-lib/static-1.7658",
  "commerce-tax-lib": "/commerce-tax-lib/static-1.385",
  "property-description-translator": "/property-description-translator/static-1.3722",
  "FireAlarmUi": "/FireAlarmUi/static-1.4396",
  "sales-templates-service-types-lib": "/sales-templates-service-types-lib/static-1.4055",
  "commerce-analytics-service-client": "/commerce-analytics-service-client/static-1.3523",
  "totals-ui-components": "/totals-ui-components/static-1.23170",
  "stripe-connect-js": "/stripe-connect-js/static-1.65",
  "advanced-menus-core": "/advanced-menus-core/static-1.14912",
  "advanced-menus-lib": "/advanced-menus-lib/static-1.11880",
  "ui-memberships-settings-lib": "/ui-memberships-settings-lib/static-1.33630",
  "demographics-service-types": "/demographics-service-types/static-1.1516",
  "automation-ui-ubb": "/automation-ui-ubb/static-1.5254",
  "blueimp-md5": "/blueimp-md5/static-1.8",
  "content-embed-lib": "/content-embed-lib/static-1.7207",
  "data-token-views": "/data-token-views/static-1.16142",
  "forms-utils-lib": "/forms-utils-lib/static-1.12302",
  "payments-embed-points-lib": "/payments-embed-points-lib/static-1.12740",
  "simple-menus-core": "/simple-menus-core/static-1.14911",
  "simple-menus-lib": "/simple-menus-lib/static-1.16428",
  "ui-addon-draggable-compat": "/ui-addon-draggable-compat/static-2.4121",
  "videoconference-integration-components": "/videoconference-integration-components/static-1.6622",
  "automation-applications-service-types": "/automation-applications-service-types/static-1.3399",
  "automation-platform-service-types": "/automation-platform-service-types/static-1.2544",
  "ContentEditorUI": "/ContentEditorUI/static-2.76719",
  "short-messages-app-service-client": "/short-messages-app-service-client/static-1.3867",
  "web-interactives-components": "/web-interactives-components/static-1.13518",
  "web-interactives-data": "/web-interactives-data/static-1.13519",
  "messaging-shared-utils-lib": "/messaging-shared-utils-lib/static-1.122",
  "messaging-user-info-utils-lib": "/messaging-user-info-utils-lib/static-1.292",
  "email-portal-health-service-types": "/email-portal-health-service-types/static-1.843",
  "commerce-totals-service-types": "/commerce-totals-service-types/static-1.3704",
  "seamless-immutable": "/seamless-immutable/static-7.6",
  "automation-ui-core": "/automation-ui-core/static-2.21274",
  "automation-ui-usage-tracking": "/automation-ui-usage-tracking/static-1.20737",
  "data-studio-ubb": "/data-studio-ubb/static-1.2297",
  "backbone": "/backbone/static-1.6",
  "campaigns-lib": "/campaigns-lib/static-1.26604",
  "collaboration-sidebar": "/collaboration-sidebar/static-1.57317",
  "content-management-data-lib": "/content-management-data-lib/static-1.5203",
  "copilot-plugins": "/copilot-plugins/static-1.10685",
  "cta-picker": "/cta-picker/static-1.36014",
  "customer-agent-discovery-components-lib": "/customer-agent-discovery-components-lib/static-1.2629",
  "editor-components": "/editor-components/static-1.13030",
  "editor-iframe-lib": "/editor-iframe-lib/static-1.8210",
  "error-messaging-js": "/error-messaging-js/static-1.5057",
  "FormsCommonComponents": "/FormsCommonComponents/static-1.85456",
  "pictos": "/pictos/static-7.181",
  "react-transition-group": "/react-transition-group/static-2.61",
  "redux-request-state": "/redux-request-state/static-1.10513",
  "SharedLegalStrings": "/SharedLegalStrings/static-1.1620",
  "smart-content-core": "/smart-content-core/static-1.42036",
  "smart-content-lib": "/smart-content-lib/static-1.42689",
  "social-composer-lib": "/social-composer-lib/static-1.58413",
  "structured-content-lib": "/structured-content-lib/static-1.24795",
  "theme-previewer-lib": "/theme-previewer-lib/static-1.52864",
  "tinymce-copilot": "/tinymce-copilot/static-1.16008",
  "xray-recommendation-lib": "/xray-recommendation-lib/static-1.7687",
  "automation-ui-routing": "/automation-ui-routing/static-1.20695",
  "sql-reporting-client-types": "/sql-reporting-client-types/static-1.5530",
  "jquery": "/jquery/static-3.6",
  "attribution-lib": "/attribution-lib/static-1.41823",
  "campaigns-utils-lib": "/campaigns-utils-lib/static-1.3022",
  "reporting-enablement": "/reporting-enablement/static-1.22328",
  "chatspot-widget-iframe": "/chatspot-widget-iframe/static-1.20611",
  "collaboration-sidebar-common": "/collaboration-sidebar-common/static-1.2114",
  "forms-ai-lib": "/forms-ai-lib/static-1.4102",
  "codemirror-dlb": "/codemirror-dlb/static-1.58278",
  "redux-mock-store": "/redux-mock-store/static-1.8",
  "redux-undo": "/redux-undo/static-1.10",
  "seo-tools-lib": "/seo-tools-lib/static-1.6295",
  "report-customization-components": "/report-customization-components/static-1.12711",
  "data-quality-ui-library": "/data-quality-ui-library/static-1.12492",
  "html-to-image": "/html-to-image/static-1.50",
  "reporting-insights-lib": "/reporting-insights-lib/static-1.1267"
}
};
